import Api from 'api'

const config = {
  baseURL: '/api/app/v1/referrals',
}
const api = new Api(config)

api.fetchAll = ({ ...rest }) => api.get('', { ...rest })
api.fetchInfo = () => api.get('/info')

export default api
